
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/products/fire-insurance",
      function () {
        return require("private-next-pages/products/fire-insurance/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/products/fire-insurance"])
      });
    }
  